import {
  Box,
  Flex,
  Text,
  Image,
  Divider,
  VStack,
  Stack,
} from "@chakra-ui/react";
import QRCode from "react-qr-code";
import Barcode from "react-barcode";
import { FC, useEffect, useState } from "react";
import logoPadrao from "../../../../assets/images/logo-alt.png";
import logoAzul from "../../../../assets/images/logo_itau_personnalite_92x92.png";
import { toast } from "react-toastify";
import "./print.css";
import { GRAY } from "../../../../constants/colors";
import {
  FaBarcode,
  FaDollarSign,
  FaQrcode,
  FaRegBookmark,
  FaRegCalendar,
} from "react-icons/fa";

interface BoletoReq {
  id: string;
  description: string;
  amount: string;
  dueDate: string;
  beneficiario: string | null;
  cpfBeneficiario: string | null;
  pagador: string;
  cpfPagador: string;
  digitableLine: string;
  barcode: string;
  dataEmissao: string;
  documentNumber: string | null;
  emv: string;
  recebedorTipoDoc: boolean;
  recebedorRazao: string;
  recebedorFantasia: string;
  dataLimitePagamento: string | null;
}

interface bolepixTaxa {
  idBolepix: string;
  tipoLancamento: string;
  mode: string;
  amount: number;
  percentage: number;
  diasAposVencimento: number;
  diaLimiteDesconto: number;
  frequency: string;
}

interface BoletoData {
  description: string;
  amountBRL: string;
  dueDate: string;
  beneficiario: string;
  cpfBeneficiario: string;
  pagador: string;
  cpfPagador: string;
  digitableLine: string;
  barcode: string;
  createdAt: string;
  documentNumber: string;
  agenciaConta: string;
  qrcodeId: string;
  updatedAt: string;
  amount: string;
  emv: string;
  multa: string;
  juros: string;
  carteira: string;
  especie: string;
  descontoValor: string;
  descontoDataLimite: string;
  instrucoes: string | null;
  abatimentos: string;
  outrasDeducoes: string;
  mora: string;
  outrosAcrescimos: string;
  quantity: string;
  recebedorRazao: string;
  bankCode: string;
  urlLogo: string | null;
  headerColor: string | null;
}

interface BoletoProps {
  logo?: string;
  emailMessage?: string;
  smsMessage?: string;
  whatsAppMessage?: string;
  notificationEnabled?: boolean;
  colorHeader?: string;
}

const BoletoComponent: FC<BoletoProps> = ({ logo, colorHeader }) => {
  const [boletoData, setBoletoData] = useState<BoletoData>({
    description: "-",
    amountBRL: "-",
    dueDate: "-",
    beneficiario: "-",
    cpfBeneficiario: "-",
    pagador: "-",
    cpfPagador: "-",
    digitableLine: "-",
    barcode: "-",
    createdAt: "-",
    documentNumber: "-",
    agenciaConta: "-",
    qrcodeId: "-",
    updatedAt: "-",
    amount: "-",
    emv: "-",
    multa: "-",
    juros: "-",
    carteira: "-",
    especie: "-",
    descontoValor: "-",
    descontoDataLimite: "-",
    instrucoes: "-",
    abatimentos: "-",
    outrasDeducoes: "-",
    mora: "-",
    outrosAcrescimos: "-",
    quantity: "-",
    recebedorRazao: "-",
    bankCode: "-",
    urlLogo: null,
    headerColor: null,
  });
  const [loading, setLoading] = useState(true);
  const [juros] = useState<bolepixTaxa | null>(null);
  const [multa] = useState<bolepixTaxa | null>(null);

  const textColorBlue = "#114AA0";

  useEffect(() => {
    fetchBankData();
  }, []);

  const fetchBankData = async () => {
    try {
      // Preview: dados de exemplo (não busca boleto real)
      const response = {
        id: "151a045c-7dd3-4fb4-ebd2-08dde59ff84a",
        description: "Modelo de Bolepix",
        amount: "5.00",
        dueDate: "2025-08-30T00:00:00",
        beneficiario: null,
        cpfBeneficiario: null,
        pagador: "Nome do Pagador",
        cpfPagador: "999.999.999-99",
        digitableLine: "34191113700000005001098024398388933133921000",
        barcode: "34191113700000005001098024398388933133921000",
        dataEmissao: "2025-08-27T16:28:58.467",
        documentNumber: null,
        emv: "00020101021226770014BR.GOV.BCB.PIX2555api.itau/pix/qr/v2/6402b1e2-1619-49c2-91b6-b5fb04a1a4585204000053039865802BR5911ZOOP BRASIL6006OSASCO62070503***6304B2D1",
        recebedorTipoDoc: true,
        recebedorRazao: "MONEDD GESTAO, SERVICOS E MEIOS DE PAGAMENTOS LTDA",
        recebedorFantasia: "MONEDD",
        dataLimitePagamento: "2025-09-29T00:00:00",
      };

      const data: BoletoReq = response;

      const amount = Number(data.amount);

      setBoletoData({
        description: data.description,
        amountBRL: `R$ ${amount.toFixed(2).replace(".", ",")}`,
        dueDate: new Date(data.dueDate).toLocaleDateString("pt-BR"),
        beneficiario: data.beneficiario || "-",
        cpfBeneficiario: data.cpfBeneficiario || "-",
        recebedorRazao: data.recebedorRazao,
        pagador: data.pagador,
        cpfPagador: data.cpfPagador,
        digitableLine: data.digitableLine,
        barcode: data.barcode,
        createdAt: new Date(data.dataEmissao).toLocaleDateString("pt-BR"),
        documentNumber: data.documentNumber || "-",
        agenciaConta: "-",
        qrcodeId: "-",
        updatedAt: data.dataLimitePagamento
          ? new Date(data.dataLimitePagamento).toLocaleDateString("pt-BR")
          : "NULL",
        amount: amount.toFixed(2).replace(".", ","),
        emv: data.emv,
        multa: "-",
        juros: "-",
        carteira: data.barcode ? data.barcode.substring(5, 7) : "-",
        especie: "-",
        descontoValor: "-",
        descontoDataLimite: "-",
        instrucoes: "",
        abatimentos: "-",
        outrasDeducoes: "-",
        mora: "-",
        outrosAcrescimos: "-",
        quantity: "-",
        bankCode: "341",
        urlLogo: null,
        headerColor: null,
      });
    } catch (err) {
      toast.error("Erro: " + err);
    } finally {
      setLoading(false);
    }
  };

  const translateFrequency = (frequency: string) => {
    switch (frequency) {
      case "DAILY":
        return "diária";
      case "MONTHLY":
        return "mensal";
      case "ANUALLY":
        return "anual";
      default:
        return frequency;
    }
  };

  function getParcelas(descricao: string): string {
    if (!descricao) {
      return "1 de 1";
    }

    const padrao = /parcela (\d+ de \d+)/i;
    const resultado = descricao.match(padrao);

    if (resultado && resultado[1]) {
      return resultado[1];
    }

    return "1 de 1";
  }

  return (
    <Box
      id="boleto-container"
      bg="white"
      p={0}
      w="1060px"
      mx="auto"
      border="1px solid #ccc"
      overflowY="auto"
    >
      <Box bg={colorHeader ? colorHeader : "#20296D"} color="white" h={30}>
        <></>
      </Box>

      <Box
        pt={4}
        mt={4}
        bg="white"
        borderRadius="md"
        borderStartRadius={14}
        borderEndRadius={20}
      >
        <Flex
          px={8}
          justify="space-between"
          flexWrap="wrap"
          rowGap={2}
          alignItems="center"
        >
          <Flex h="100%">
            <Image
              src={logo == null ? logoPadrao : logo}
              alt="Boleto Logo"
              height="45px"
              maxH="45px"
              maxW="300px"
              objectFit="contain"
              objectPosition="left center"
            />
            <Flex w={1} minH="100%" bg="white" mr={4}>
              <></>
            </Flex>
          </Flex>
        </Flex>

        <Flex
          px={8}
          justify="space-between"
          flexWrap="wrap"
          rowGap={3}
          mt={10}
          alignItems="center"
        >
          <Flex
            minW="280px"
            minH={"100px"}
            align="center"
            backgroundColor={"#FEEDDF"}
            p={2}
            borderRadius="md"
            mt={4}
          >
            <Flex
              w="72px"
              h="72px"
              bg={"#F47C27"}
              borderRadius="50%"
              alignItems="center"
              justifyContent="center"
              mr={6}
              ml={4}
            >
              <FaRegBookmark color="white" size="28px" />
            </Flex>
            <Flex flexDir="column">
              <Text fontSize="1.4rem">Parcela</Text>
              <Text fontSize="1.4rem" fontWeight="bold">
                {getParcelas(boletoData.description)}
              </Text>
            </Flex>
          </Flex>
          <Flex
            minW="280px"
            minH={"100px"}
            align="center"
            backgroundColor={"#FEEDDF"}
            p={2}
            borderRadius="md"
            mt={4}
          >
            <Flex
              w="72px"
              h="72px"
              bg={"#F47C27"}
              borderRadius="50%"
              alignItems="center"
              justifyContent="center"
              mr={6}
              ml={4}
            >
              <FaDollarSign color="white" size="28px" />
            </Flex>
            <Flex flexDir="column">
              <Text fontSize="1.4rem">Valor</Text>
              <Text fontSize="1.4rem" fontWeight="bold">
                {boletoData.amountBRL}
              </Text>
            </Flex>
          </Flex>
          <Flex
            minW="280px"
            minH={"100px"}
            align="center"
            backgroundColor={"#FEEDDF"}
            p={2}
            borderRadius="md"
            mt={4}
          >
            <Flex
              w="72px"
              h="72px"
              bg={"#F47C27"}
              borderRadius="50%"
              alignItems="center"
              justifyContent="center"
              mr={6}
              ml={4}
            >
              <FaRegCalendar color="white" size="28px" />
            </Flex>
            <Flex flexDir="column">
              <Text fontSize="1.4rem">Vencimento</Text>
              <Text fontSize="1.4rem" fontWeight="bold">
                {boletoData.dueDate}
              </Text>
            </Flex>
          </Flex>
        </Flex>

        <Stack
          px={8}
          mt={4}
          direction="row"
          justifyContent="space-between"
          spacing={8}
          wrap="wrap"
          minW="600px"
        >
          <VStack align="start" spacing={1} flex={2}>
            <Text fontSize="md" color={textColorBlue}>
              Nome do Beneficiário
            </Text>
            <Text color={GRAY}>
              MONEDD GESTAO, SERVICOS E MEIOS DE PAGAMENTOS LTDA
            </Text>
            <Text fontSize="md" color={GRAY}>
              CPF/CNPJ: 32.505.213/0001-61
            </Text>
          </VStack>
          <VStack align="start" spacing={1} flex={1}>
            <Text fontSize="md" color={textColorBlue}>
              Nome do Recebedor
            </Text>
            <Text fontSize={"md"} color={GRAY}>
              {boletoData.recebedorRazao}
            </Text>
          </VStack>
        </Stack>

        <Flex direction="column" w="100%" justify="center" mt={4} p={4}>
          <Divider height="1px" bg={textColorBlue} />
          <Flex gap={6} align="center" w="100%" bg={"#F2F9FC"} px={12} pb={12}>
            <Flex
              direction="column"
              w="100%"
              justify="start"
              align="start"
              flexWrap="wrap"
              gap={6}
            >
              <Flex w="100%" align="start" justify={"start"}>
                <Text
                  fontSize="1.5rem"
                  fontWeight="bold"
                  mt={-10}
                  color={textColorBlue}
                >
                  Como Pagar
                </Text>
              </Flex>
              <Box flex={1}>
                <Flex align="center">
                  <Flex
                    mr={2}
                    bg={"#CAE9F9"}
                    p={2}
                    borderRadius="50%"
                    align="center"
                    justify="center"
                  >
                    <FaBarcode size={14} color={textColorBlue} />
                  </Flex>
                  <Text fontSize="sm" color={GRAY} fontWeight={"bold"}>
                    Escaneie o código de barras
                  </Text>
                </Flex>
                <Box mt={2} w="100%">
                  <Barcode
                    value={boletoData.barcode}
                    width={1.5}
                    height={50}
                    displayValue={false}
                    margin={0}
                  />
                </Box>
              </Box>
            </Flex>
            {/* QR Code PIX removido a pedido do cliente
            <Box flexShrink={0} mt={10}>
              <Flex align="center">
                <Flex
                  mr={2}
                  bg={"#CAE9F9"}
                  p={2}
                  borderRadius="50%"
                  align="center"
                  justify="center"
                >
                  <FaQrcode size={14} color={textColorBlue} />
                </Flex>
                <Text fontSize="sm" color={GRAY} fontWeight={"bold"}>
                  Pagamento via pix
                </Text>
              </Flex>
              <Flex
                align="center"
                justify="center"
                border={"2px solid #CAE9F9"}
                mt={2}
                p={2}
                bg={"#ffffff"}
                borderRadius="md"
              >
                <QRCode value={boletoData.emv} size={140} />
              </Flex>
            </Box>
            */}
          </Flex>
        </Flex>

        <Divider
          my={4}
          borderStyle="dashed"
          borderColor={"#212121"}
          borderWidth="1px"
          w={"100% - 1px"}
        />

        <Box fontSize="xs" border="1px solid black" m={4}>
          <Flex borderBottom="1px solid black">
            <Flex
              borderRight="1px solid black"
              p={1}
              w="25%"
              justifyItems="center"
              align="center"
              alignContent="center"
            >
              <Image src={logoAzul} alt="Logo Itaú" height="60px" mr={2} />
              <Text fontSize="1rem" fontWeight="bold">
                BANCO ITAÚ SA
              </Text>
            </Flex>
            <Box
              borderRight="1px solid black"
              p={1}
              w="15%"
              alignContent="center"
              justifyItems="center"
            >
              <Text fontSize="1rem" fontWeight="bold">
                {boletoData.bankCode}
              </Text>
            </Box>
            <Box p={1} textAlign="right" w="60%" flex={4} alignContent="center">
              <Text fontSize="1rem" fontWeight="bold">
                {boletoData.digitableLine}
              </Text>
            </Box>
          </Flex>

          <Flex borderBottom="1px solid black">
            <Box borderRight="1px solid black" p={1} w="70%">
              <Text color={GRAY}>Local de pagamento</Text>
              <Text>
                Até o vencimento pague em qualquer banco ou correspondente
                bancário.
              </Text>
            </Box>
            <Box p={1} flex={1} w="30%">
              <Text color={GRAY}>Vencimento</Text>
              <Text fontWeight="bold">{boletoData.dueDate}</Text>
            </Box>
          </Flex>

          <Flex borderBottom="1px solid black">
            <Box borderRight="1px solid black" p={1} w="70%">
              <Text color={GRAY}>Beneficiário</Text>
              <Text fontWeight="bold">CPF/CNPJ: 32.505.213/0001-61</Text>
            </Box>
            <Box p={1} w="30%">
              <Text color={GRAY}>Agência/Conta</Text>
              <Text fontWeight="bold"></Text>
            </Box>
          </Flex>

          <Flex borderBottom="1px solid black">
            <Box borderRight="1px solid black" p={1} w="18%">
              <Text color={GRAY}>Data do documento</Text>
              <Text fontWeight="bold">{boletoData.createdAt}</Text>
            </Box>
            <Box borderRight="1px solid black" p={1} w="18%">
              <Text color={GRAY}>N. do documento</Text>
              <Text fontWeight="bold">{boletoData.documentNumber}</Text>
            </Box>
            <Box borderRight="1px solid black" p={1} w="10%">
              <Text color={GRAY}>Espécie doc.</Text>
              <Text fontWeight="bold"></Text>
            </Box>
            <Box borderRight="1px solid black" p={1} w="8%">
              <Text color={GRAY}>Aceite</Text>
              <Text></Text>
            </Box>
            <Box borderRight="1px solid black" p={1} w="16%">
              <Text color={GRAY}>Data process.</Text>
              <Text fontWeight="bold">{boletoData.createdAt}</Text>
            </Box>
            <Box p={1} w="30%">
              <Text color={GRAY}>Número Documento</Text>
              <Text fontWeight="bold">{boletoData.documentNumber}</Text>
            </Box>
          </Flex>

          <Flex borderBottom="1px solid black">
            <Box w="18%" borderRight="1px solid black" p={1}>
              <Text color={GRAY}>Uso do banco</Text>
              <Text></Text>
            </Box>
            <Box w="9%" borderRight="1px solid black" p={1}>
              <Text color={GRAY}>Carteira</Text>
              <Text></Text>
            </Box>
            <Box w="9%" borderRight="1px solid black" p={1}>
              <Text color={GRAY}>Espécie</Text>
              <Text></Text>
            </Box>
            <Box w="18%" borderRight="1px solid black" p={1}>
              <Text color={GRAY}>Quantidade</Text>
              <Text></Text>
            </Box>
            <Box w="16%" borderRight="1px solid black" p={1}>
              <Text color={GRAY}>Valor</Text>
              <Text>R$ {boletoData.amount}</Text>
            </Box>
            <Box w="30%" p={1}>
              <Text color={GRAY}>(+) Valor Documento</Text>
              <Text>R$ {boletoData.amount}</Text>
            </Box>
          </Flex>

          <Flex borderBottom="1px solid black">
            <Box w="70%" borderRight="1px solid black" p={1}>
              <Text color={GRAY}>
                Informações de responsabilidade do beneficiário
              </Text>
              {juros || multa ? (
                <Text>Após o vencimento será aplicado:</Text>
              ) : (
                <></>
              )}
              {juros && (
                <Text>
                  - Juros de{" "}
                  <b>
                    {juros.mode.includes("FIXED") ||
                    juros.mode.includes("AMOUNT")
                      ? `R$ ${(juros.amount / 100)
                          .toFixed(2)
                          .replace(".", ",")}`
                      : `${(juros.percentage / 100)
                          .toFixed(2)
                          .replace(".", ",")}%`}
                  </b>{" "}
                  com a frequência <b>{translateFrequency(juros.frequency)}</b>
                </Text>
              )}
              {multa && (
                <Text>
                  - Multa de{" "}
                  <b>
                    {multa.mode.includes("FIXED") ||
                    multa.mode.includes("AMOUNT")
                      ? `R$ ${(multa.amount / 100)
                          .toFixed(2)
                          .replace(".", ",")}`
                      : `${(multa.percentage / 100)
                          .toFixed(2)
                          .replace(".", ",")}%`}
                  </b>{" "}
                  com a frequência <b>{translateFrequency(multa.frequency)}</b>
                </Text>
              )}
            </Box>
            <Flex w="30%" flexDir="column">
              <Box p={1} borderBottom="1px solid black">
                <Text minH={"1rem"} color={GRAY}>
                  (-) Descontos/Abatimentos
                </Text>
                <Text fontWeight="bold" minH={"1rem"}></Text>
              </Box>
              <Box p={1} borderBottom="1px solid black">
                <Text minH={"1rem"} color={GRAY}>
                  (-) Mora/Multa
                </Text>
                <Text fontWeight="bold" minH={"1rem"}></Text>
              </Box>
              <Box p={1} borderBottom="1px solid black">
                <Text minH={"1rem"} color={GRAY}>
                  (-) Valor cobrado
                </Text>
                <Text minH={"1rem"}></Text>
              </Box>
              <Box p={1}>
                <Text minH={"1rem"}></Text>
                <Text minH={"1rem"}></Text>
              </Box>
            </Flex>
          </Flex>
          <Flex borderBottom="1px solid black">
            <Box w="100%" p={1}>
              <Text color={GRAY}>Pagador CPF/CNPJ</Text>
              <Text>
                {boletoData.pagador} - CPF/CNPJ: {boletoData.cpfPagador}
              </Text>
            </Box>
          </Flex>
          <Flex h={"4rem"}>
            <Box w="100%" p={1}>
              <Text color={GRAY}>Sacador/Avalista</Text>
              <Text></Text>
            </Box>
            <Box w="100%" p={1}>
              <Text color={GRAY} h={"1.2rem"}></Text>
              <Text>CPF/CNPJ:</Text>
            </Box>
            <Box w="100%" p={1}>
              <Text color={GRAY}>Autenticação mecânica</Text>
              <Text></Text>
            </Box>
            <Box w="100%" p={1}>
              <Text color={GRAY}>Ficha de compensação</Text>
              <Text></Text>
            </Box>
          </Flex>
        </Box>
        <Flex justifyContent="start" m={4}>
          <Barcode
            value={boletoData.barcode}
            width={2.3}
            height={50}
            displayValue={false}
          />
        </Flex>
      </Box>
    </Box>
  );
};

export default BoletoComponent;
